import {NgModule, CUSTOM_ELEMENTS_SCHEMA, forwardRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxSummernoteModule } from 'node_modules/ngx-summernote';
import { NgxSummernoteCustomModule } from 'src/app/lib/ngx-summernote-custom.module';

import { ProductsRoutingModule } from './products-routing.module';
import { SharedModule } from 'src/app/shared';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProductsListComponent } from './products-list.component';
import { ProductsDetailComponent } from './products-detail/products-detail.component';
import {
  ProductsAnalyticsComponent,
  ProductsDistributorsComponent,
  ProductsFormComponent,
  ProductsQuestionsComponent,
  ProductQuestionListComponent,
  ProductsReviewsComponent,
  ProductReviewHiddenComponent,
  ProductReviewListComponent,
  ProductsStoresComponent,
  ProductsDocumentsComponent,
  ProductDocumentAssignComponent,
  ProductsSettingComponent,
  SettingMessageComponent,
  SettingCreateMessageComponent,
  SettingRelatedComponent,
  SettingCreateRelatedComponent,
  AddProductDistributorsComponent,
  EditProductDistributorsComponent,
  ProductDocumentUpdateComponent,
  ProductsElabelComponent,
  ProductsElabelHistoryComponent,
} from './products-detail';
import { ProductsAddComponent } from './products-add/products-add.component';
import { ProductsUpdateComponent } from './products-update/products-update.component';
import { ProductsDeleteComponent } from './products-delete/products-delete.component';
import { ProductsHistoryComponent } from './products-detail/products-history/products-history.component';
import { ProductLoyaltyComponent } from './products-detail/product-loyalty/product-loyalty.component';
import { ProductAddQuickComponent } from './product-add-quick/product-add-quick.component';
import { ReadMoreFileComponent } from './products-detail/products-form/read-more-file/read-more-file.component';
import {ImageSelectDirective} from "./products-detail/products-form/directive/image-select.directive";
import {BusinessModule} from "../business.module";
import { ModalProductBadgeComponent } from './modal-product-badge/modal-product-badge.component';
import { ModalPassportComponent } from './modal-passport/modal-passport.component';
import { DetailProductPassportComponent } from './detail-product-passport/detail-product-passport.component';
import {QRCodeModule} from 'angularx-qrcode';
@NgModule({
  declarations: [
    ProductsDetailComponent,
    ProductsListComponent,
    ProductsAnalyticsComponent,
    ProductsDistributorsComponent,
    ProductsFormComponent,
    ProductsQuestionsComponent,
    ProductsReviewsComponent,
    ProductsStoresComponent,
    ProductsElabelComponent,
    ProductsSettingComponent,
    ProductsAddComponent,
    SettingMessageComponent,
    SettingRelatedComponent,
    SettingCreateMessageComponent,
    SettingCreateRelatedComponent,
    ProductsDocumentsComponent,
    AddProductDistributorsComponent,
    EditProductDistributorsComponent,
    ProductDocumentAssignComponent,
    ProductReviewHiddenComponent,
    ProductReviewListComponent,
    ProductQuestionListComponent,
    ProductDocumentUpdateComponent,
    ProductsUpdateComponent,
    ProductsDeleteComponent,
    ProductsHistoryComponent,
    ProductsElabelHistoryComponent,
    ProductLoyaltyComponent,
    ProductAddQuickComponent,
    ReadMoreFileComponent,
    ImageSelectDirective,
    ModalProductBadgeComponent,
    ModalPassportComponent,
    DetailProductPassportComponent
  ],
  imports: [

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProductsRoutingModule,
    NgZorroAntdModule,
    NgxBarcodeModule,
    NgxSummernoteModule,
    NgxSummernoteCustomModule,
    DragDropModule,
    forwardRef(() => SharedModule),
    SharedModule,
    QRCodeModule
  ],
  entryComponents: [ProductsAddComponent,     ProductAddQuickComponent, ReadMoreFileComponent, ModalProductBadgeComponent, ModalPassportComponent],
  exports: [ProductsAddComponent, SettingCreateMessageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
})
export class ProductsModule {}
